import { extraFeeTypes, refundMethods } from './constants'

export const getExtraCredit = (refundMethod, currency, language) => {
  let value = ''

  if (refundMethod?.extra_value && Number(refundMethod?.extra_value) > 0) {
    if (refundMethod.extra_value_type === extraFeeTypes.fixedAmount) {
      value = new Intl.NumberFormat(language, { style: 'currency', currency }).format(refundMethod.extra_value)
    } else if (refundMethod.extra_value_type === extraFeeTypes.percentage) {
      value = `${parseFloat(refundMethod.extra_value)}%`
    } else if (refundMethod.extra_value_type === extraFeeTypes.deliveryMethodFee) {
      value = new Intl.NumberFormat(language, { style: 'currency', currency }).format(refundMethod.extra_value)
    }

    return `+${value}`
  }
}

export const getRefundMethodName = (refundMethod, language, t) => {
  const customName = refundMethod.useCustomName && refundMethod.display[language]

  return customName || t(refundMethods[refundMethod.name].name)
}
